export default () => {
  return {
    data: () => ({
      _token: null,
    }),
    methods: {
      csrf_token: function (val) {
        this._token = val;
      },
    },
  };
};
